var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[(_vm.isNavigationVisible)?_c('navigation-drawer'):_vm._e(),_c('v-main',[_c('router-view')],1),(_vm.isSidebarVisible)?_c('right-side-contents'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }